/**
 * How many dishes the workspace has of its own — the one number, not the
 * rows. For anything that needs to know whether there are any at all before
 * it offers something that only makes sense once there are: the Dish search
 * cannot be kept to your own dishes when you have none, since every search
 * would then find nothing.
 *
 * Asked for as a page of one: `GET /api/v1/workspace-foods/` answers with the
 * total whatever the page size, and a page of ten costs ten full rows of
 * nutrition for a figure that is on the envelope.
 */

import { useQuery } from "@tanstack/react-query";
import { useTokenGetter } from "../../auth/hooks/useTokenGetter";
import { fetchDishesPage } from "../services/dishesService";

export const OWN_DISH_COUNT_QUERY_KEY = ["dishes", "count"] as const;

/** `undefined` until the read lands, or if it fails — not known, not zero. */
export function useOwnDishCount(): number | undefined {
  const getToken = useTokenGetter();

  const query = useQuery({
    queryKey: OWN_DISH_COUNT_QUERY_KEY,
    queryFn: async ({ signal }) =>
      (await fetchDishesPage(getToken, { page: 1, pageSize: 1, signal })).count,
  });

  return query.data;
}

export default useOwnDishCount;
